module.exports = __webpack_public_path__ + "static/vilniausrajono-03cd5deb5e834ebc32bda83298f74041.png";